import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from 'shared/utils/type.utils';

export const getOrdinalSuffix = (value: string) => {
  value = value.toString();
  if (value.length > 1) {
    const secondToLastDigit = value.charAt(value.length - 2);
    if (secondToLastDigit === '1') {
      return 'th';
    }
  }

  const lastDigit = value.charAt(value.length - 1);
  switch (lastDigit) {
    case '1':
      return 'st';
    case '2':
      return 'nd';
    case '3':
      return 'rd';
    default:
      return 'th';
  }
};

@Pipe({ name: 'monthDayDisplay' })
export class MonthDayDisplay implements PipeTransform {
  transform(month: string): string {
    if (isNullOrUndefined(month)) return '';
    if (month === 'L') {
      return 'Last Day';
    }
    return `${month}${getOrdinalSuffix(month)} day`;
  }
}

// Takes in a string value for the the day of month(1-31)
// Returns the value with the ordinal suffix.
// Ex: 1 -> 1st, 2 -> 2nd, 3->3rd and so on.
@Pipe({ name: 'monthDay' })
export class MonthDay implements PipeTransform {
  transform(monthDay: string): string {
    if (isNullOrUndefined(monthDay)) return '';
    return `${monthDay}${getOrdinalSuffix(monthDay)}`;
  }
}

@Pipe({ name: 'prependZeroToTimeValue' })
export class PrependZeroToTimeValue implements PipeTransform {
  transform(value: number): string {
    if (isNullOrUndefined(value)) return '0';
    if (value < 10) {
      return '0' + value;
    }
    return value.toString();
  }
}
